export type BaseVxeTableRowKey =
  | string
  | ((record: Record<string, unknown>) => string | number)

export function resolveRowKeyField(rowKey?: BaseVxeTableRowKey): string | undefined {
  return typeof rowKey === 'string' ? rowKey : undefined
}

export function getRowKeyValue(
  record: Record<string, unknown>,
  rowKey?: BaseVxeTableRowKey
): string | number {
  if (typeof rowKey === 'function') {
    return rowKey(record)
  }
  if (rowKey) {
    return record[rowKey] as string | number
  }
  return record._X_ROW_KEY as string | number
}
